<template>
  <div v-if="hasSrc" :style="backgroundImage"></div>
</template>

<script>
  import Vibrant from 'node-vibrant'

  export default {
    components: {
      Vibrant
    },

    props: {
      src: {
        type: String,
        default: ''
      }
    },

    data () {
      return {
        hasSrc: this.src !== '',
        backgroundImage: {
          backgroundImage: `url(${this.src})`
        },
        fallbackColor: [20, 120, 220]
      }
    },

    methods: {
      emitThemeColor (color) {
        this.$emit('themecolorextracted', color)
      }
    },

    mounted () {
      if (!this.hasSrc) return this.emitThemeColor(this.fallbackColor)

      new Vibrant(this.src).getPalette((err, palette) => {
        if (err) return this.emitThemeColor(this.fallbackColor)

        let paletteColor = palette.Vibrant ||
                           palette.LightVibrant ||
                           palette.DarkVibrant ||
                           palette.LightMuted ||
                           palette.Muted ||
                           palette.DarkMuted

        this.emitThemeColor(paletteColor._rgb)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Cover.vue